/* Main Structure Is 
	[
		{id, value, filter : Default = value.toLowerCase().split(" ").join("-")}
	]
*/

const CategoriesData = [
	{ id: 1, value: "Meat Dishes", filter: "meat" },
	{ id: 2, value: "Vegetables" },
	{ id: 3, value: "Seafoods" },
	{ id: 4, value: "Pizza" },
	{ id: 5, value: "Randomize", filter: "random" }
];
export default CategoriesData;
